import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export const About = () => {
  return <section id="nosotras" className="py-20 md:py-32 bg-brand-bg" data-id="element-12">
      <div className="max-w-6xl mx-auto px-6" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-15">
            <div className="relative rounded-3xl overflow-hidden aspect-square shadow-2xl" data-id="element-16">
              <div className="absolute inset-0 bg-brand-pink/10 mix-blend-overlay z-10 pointer-events-none" data-id="element-17"></div>
              <video src="https://cdn.magicpatterns.com/uploads/igNb2doBozvU4tZWBzCyRo/1780932496389.publer.com.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-18" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-brand-gold/20 rounded-full blur-2xl -z-10" data-id="element-19"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-start" data-id="element-20">
            <div className="inline-block px-4 py-1.5 rounded-full bg-gradient-brand text-white text-xs font-bold tracking-wider uppercase mb-6 shadow-sm" data-id="element-21">
              Sobre Nosotras
            </div>

            <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-dark mb-6 leading-tight" data-id="element-22">
              Un espacio creado con pasión
            </h2>

            <p className="text-lg text-brand-dark/70 mb-8 leading-relaxed" data-id="element-23">
              En Beauty Lab creemos que la belleza es una experiencia. Nuestro
              estudio está diseñado para que te sientas cómoda, cuidada y
              completamente vos. Trabajamos con productos de primera calidad y
              técnicas actualizadas para brindarte los mejores resultados.
            </p>

            <div className="flex flex-col gap-4 mb-10" data-id="element-24">
              {['Productos premium', 'Técnicas actualizadas', 'Ambiente cálido'].map((feature, i) => <div key={i} className="flex items-center gap-3 bg-white px-4 py-3 rounded-full shadow-sm w-fit border border-brand-pink/10" data-id="element-25">
                  <div className="w-6 h-6 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-magenta" data-id="element-26">
                    <Check size={14} strokeWidth={3} data-id="element-27" />
                  </div>
                  <span className="font-medium text-brand-dark/80" data-id="element-28">
                    {feature}
                  </span>
                </div>)}
            </div>

            <a href="#galeria" className="text-brand-magenta font-semibold border-b-2 border-brand-magenta pb-1 hover:text-brand-pink hover:border-brand-pink transition-colors flex items-center gap-2" data-id="element-29">
              Conocé nuestro trabajo
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
};